"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Provider_1 = require("@becrop/components/Common/ThirdParties/Abstract/Models/Provider");
const axios_1 = __importDefault(require("axios"));
const ProviderArea_1 = require("@becrop/components/Common/ThirdParties/Abstract/Models/ProviderArea");
const endpoints = {
    providerAreas: '/integrations/leaf/areas/list?provider=',
    importAreas: '/integrations/leaf/areas',
    providerList: '/integrations/leaf/providers/list',
    connect: '/integrations/leaf/auth',
    disconnect: '/integrations/leaf/unlink/user/provider'
};
class ThirdPartiesController {
    constructor(id) {
        this.leafUserId = id;
        this.providers = new Array();
        this.providerAreas = new Array();
        this.activeProviderAreas = new Array();
        this.redirectedProvider = new Provider_1.Provider({});
        this.isFetching = false;
        this.comesFromRedirection = false;
        this.activeGisAreaId = null;
    }
    async fetchProvidersList() {
        const url = endpoints.providerList;
        try {
            this.isFetching = true;
            const call = await fetch(url);
            const response = await call.json();
            this.providers = response.providers.map((p) => new Provider_1.Provider(p));
            this.isFetching = false;
        }
        catch (e) {
            console.log(e);
        }
    }
    async fetchProviderAreas(p, t) {
        const url = endpoints.providerAreas + p.name + '&type=' + t + '&page=' + 0 + '&size=' + 200;
        try {
            this.isFetching = true;
            const call = await fetch(url);
            const response = await call.json();
            this.activeProviderAreas = response.map((ap) => new ProviderArea_1.ProviderArea(ap.areas));
            this.isFetching = false;
        }
        catch (e) {
            console.log(e);
        }
    }
    async connectProvider(p, gisAreaId = null) {
        const url = endpoints.connect;
        try {
            const data = {
                provider: p.name,
                origin: window.location.pathname + window.location.search,
                gis_area_id: gisAreaId
            };
            const call = await axios_1.default.post(url, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const respURL = call.data.url;
            window.open(respURL, '_blank');
        }
        catch (e) {
            console.log(e);
        }
    }
    async disconnectProvider(p) {
        const url = endpoints.disconnect;
        try {
            const data = {
                "provider": p.id,
                "leaf_user": this.leafUserId
            };
            const call = await axios_1.default.post(url, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            // @ts-ignore
            if (this.providers.find((prov) => prov === p)) {
                // @ts-ignore
                this.providers.find((prov) => prov === p).linked = false;
            }
            return call;
        }
        catch (e) {
            console.log(e);
        }
    }
    async addSelected(b, m, a) {
        const url = endpoints.importAreas;
        try {
            const areas_ids = b.map((block) => block.leafFieldId);
            const data = {
                areas_ids: areas_ids,
                type: m,
                gis_area_id: a.meta.id,
                source: 'tracking'
            };
            return await axios_1.default.post(url, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        }
        catch (e) {
            console.error(e);
            return e;
        }
    }
    get activeGisArea() {
        return this.activeGisAreaId;
    }
    checkIfRedirected() {
        const currentUrl = window.location.search;
        const paramsArray = currentUrl.split(/[&?]/);
        const paramsObject = {
            connected: '',
            provider: '',
            proposal: '',
            gis_area_id: null
        };
        // Iterate through the array and extract key-value pairs
        paramsArray.forEach((param) => {
            const [key, value] = param.split('=');
            if (key && value) {
                // @ts-ignore
                paramsObject[key] = value;
            }
        });
        (paramsObject.connected.length > 0 && paramsObject.provider.length > 0)
            ? this.comesFromRedirection = true
            : this.comesFromRedirection = false;
        if (this.comesFromRedirection) {
            // @ts-ignore
            if (this.providers.find((p) => p.name === paramsObject.provider)) {
                // @ts-ignore
                this.redirectedProvider = this.providers.find((p) => p.name === paramsObject.provider);
                this.redirectedProvider.linked = (paramsObject.connected === 'true') ? true : false;
            }
            if (paramsObject.proposal.length > 0) {
                let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?proposal=' + paramsObject.proposal;
                window.history.pushState({ path: newurl }, '', newurl);
            }
            else {
                let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.pushState({ path: newurl }, '', newurl);
            }
            if (paramsObject.gis_area_id !== null) {
                this.activeGisAreaId = paramsObject.gis_area_id;
            }
        }
    }
}
exports.default = ThirdPartiesController;
